/* Source: src/mt-includes/js/src/core/form/init.js*/
angular.module('website.core.form', ['ng']);
